import SwScrollView from './sw-scroll-view.vue';

export {
  SwScrollView,
};
